import innerUseLocalStorageState from "use-local-storage-state";
import { useAuthGuardContext } from "~/route-guards/withAuthGuard";

/** Will automatically be namespaced by the current user's ID. */
export function useLocalStorageState<T>(namespace: string, key: string, defaultValue: T) {
  const { currentUserId } = useAuthGuardContext();
  return innerUseLocalStorageState(`comms.${currentUserId}.${namespace}.${key}`, { defaultValue });
}
